<template>
  <div class="rp">
    <div class="rp-title">Report preview</div>
    <img src="@/assets/report-preview.png" alt="Report preview" width="824" />
  </div>
</template>

<script>
export default {
  name: 'ReportPreview',
}
</script>

<style scoped>
.rp {
  display: flex;
  width: 100%;
  padding: 80px 60px 120px 60px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: #F9FAFF;
}

.rp-title {
  color: var(--Font-navy, #0A1250);
  text-align: center;

  /* H1 */
  font-family: "Open Sans";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 125%; */
  /* 60px */
}
</style>
